import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { api, ApiError } from './api';
import type { Me } from './types';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await api.get<Me>('/auth/me');
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
  });
}

/**
 * Signs out and wipes everything this learner left in the browser, so the next
 * child on a shared lab computer starts clean (spec AT12).
 */
export function useSignOut() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return async () => {
    try {
      await api.post('/auth/logout');
    } finally {
      qc.clear();
      try {
        sessionStorage.clear();
        localStorage.clear();
      } catch {
        /* storage blocked */
      }
      window.speechSynthesis?.cancel();
      navigate('/sign-in', { replace: true });
    }
  };
}
